'use client';

import { recordSquarePostView } from '@/app/actions/share';
import { useEffect, useState } from 'react';

declare global {
  interface Window {
    __supprSquarePostViews?: Set<string>;
  }
}

export default function SquarePostViewCount({
  postId,
  token,
  initialCount,
}: {
  postId: string;
  token: string;
  initialCount: number;
}) {
  const [count, setCount] = useState(initialCount);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const viewed = (window.__supprSquarePostViews ??= new Set<string>());
    const key = `${postId}:${token}`;
    if (viewed.has(key)) {
      return;
    }
    viewed.add(key);
    void recordSquarePostView(postId, token)
      .then((nextCount) => {
        setCount((current) => Math.max(current, nextCount));
      })
      .catch((error) => {
        console.error(error);
      });
  }, [postId, token]);

  return <>{count}</>;
}
